import { getCustomerSavedFitFromCookies } from '@helpers/customer/fit'
import { RootState } from '@store/redux/reducers'

export function getCustomerFitCondensed(state: RootState) {
  const { fit, updatedAt } = state.customerFit || {}
  const customerFit = { fit: { ...fit?.top, ...fit?.bottom }, updatedAt }

  if (Object.keys(customerFit.fit).length === 0) {
    const savedFit = getCustomerSavedFitFromCookies()

    return { ...customerFit, fit: savedFit || {} }
  }

  return customerFit
}